import PendingPayments from "./PendingPayments";

export default PendingPayments;
